"use strict";

exports.__esModule = true;
exports.EXPERIMENT_MEDIA_UPLOAD_LIMITS = exports.EXPERIMENT_PLAIN_TEXT_COMMENTS = exports.EXPERIMENT_LINK_PREVIEW = exports.EXPERIMENT_RECENT_ACTIVITY_CATS = exports.EXPERIMENT_VISUAL_UPDATE = exports.EXPERIMENT_NEW_QA_KEYS = exports.EXPERIMENT_BUSINESS_MANAGER = exports.EXPERIMENT_RECENT_ACTIVITY = exports.EXPERIMENT_RADIO_INPUT_SUBTITLES = exports.EXPERIMENT_LOCAL_DRAFT = exports.EXPERIMENT_PAID_PLANS = void 0;
var EXPERIMENT_PAID_PLANS = 'specs.wixForum.PaidPlans';
exports.EXPERIMENT_PAID_PLANS = EXPERIMENT_PAID_PLANS;
var EXPERIMENT_LOCAL_DRAFT = 'specs.wixForum.LocalDraft';
exports.EXPERIMENT_LOCAL_DRAFT = EXPERIMENT_LOCAL_DRAFT;
var EXPERIMENT_RADIO_INPUT_SUBTITLES = 'specs.wixForum.RadioInputSubtitles';
exports.EXPERIMENT_RADIO_INPUT_SUBTITLES = EXPERIMENT_RADIO_INPUT_SUBTITLES;
var EXPERIMENT_RECENT_ACTIVITY = 'specs.wixForum.TrackRecentActivities';
exports.EXPERIMENT_RECENT_ACTIVITY = EXPERIMENT_RECENT_ACTIVITY;
var EXPERIMENT_BUSINESS_MANAGER = 'specs.wixForum.BusinessManager';
exports.EXPERIMENT_BUSINESS_MANAGER = EXPERIMENT_BUSINESS_MANAGER;
var EXPERIMENT_NEW_QA_KEYS = 'specs.wixForum.NewQAKeys';
exports.EXPERIMENT_NEW_QA_KEYS = EXPERIMENT_NEW_QA_KEYS;
var EXPERIMENT_VISUAL_UPDATE = 'specs.wixForum.VisualUpdate';
exports.EXPERIMENT_VISUAL_UPDATE = EXPERIMENT_VISUAL_UPDATE;
var EXPERIMENT_RECENT_ACTIVITY_CATS = 'specs.wixForum.RecentActivityCats';
exports.EXPERIMENT_RECENT_ACTIVITY_CATS = EXPERIMENT_RECENT_ACTIVITY_CATS;
var EXPERIMENT_LINK_PREVIEW = 'specs.wixForum.LinkPreview';
exports.EXPERIMENT_LINK_PREVIEW = EXPERIMENT_LINK_PREVIEW;
var EXPERIMENT_PLAIN_TEXT_COMMENTS = 'specs.wixForum.PlainTextComments';
exports.EXPERIMENT_PLAIN_TEXT_COMMENTS = EXPERIMENT_PLAIN_TEXT_COMMENTS;
var EXPERIMENT_MEDIA_UPLOAD_LIMITS = 'specs.wixForum.MediaUploadLimits';
exports.EXPERIMENT_MEDIA_UPLOAD_LIMITS = EXPERIMENT_MEDIA_UPLOAD_LIMITS;